import type { ReactNode } from 'react'
import { ThemeProvider } from 'styled-components'
import useRebrandVersion from 'hooks/useRebrandVersion'
import { getBrandTheme } from './paletteVersion'

interface Props {
  brand: string
  children: ReactNode
}

/** Selects the complete brand theme from static rebrand configuration. */
function BrandedThemeProvider({ brand, children }: Props) {
  const rebrandVersion = useRebrandVersion()
  const theme = getBrandTheme(brand, rebrandVersion)

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}

export default BrandedThemeProvider
